import { unifiedAgentEvent } from './unifiedAgentEvent'

export const unifiedAgentCreateOpenedLogEvent = unifiedAgentEvent('Unified_Agent_Create_Opened')
